// extracted by mini-css-extract-plugin
module.exports = {"loader":"jut__Loader__loader","text":"jut__Loader__text","loaderAlertWrapper":"jut__Loader__loaderAlertWrapper"};